export const calendarItems = ['Daily Schedule', 'Weekly Schedule', 'All Events']